import React, {useState} from 'react';
import {TextArea} from '@react-ui-org/react-ui';

export const PreguntaEncuesta = (props) => {
	const {
		id,
		pregunta,
		modificarPregunta,
		preguntaObligatoria,
		eliminarPregunnta,
		duplicarRespuesta,
		modificarNumeroMaximo,
		numeroMaximoPuntuacion,
	} = props;

	const [NumeroPreguntas, setNumeroPreguntas] = useState([1, 2, 3, 4, 5]);

	return (
		<div className='preguntaEncuesta'>
			<div className='inputFechaFacturas '>
				<input
					type='text'
					placeholder={'Pregunta ' + pregunta.id}
					onChange={(e) => modificarPregunta(e, id)}
				/>
				{pregunta.obligatoria && (
					<div className='centrador'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='10'
							height='10'
							fill='currentColor'
							className='bi bi-asterisk'
							viewBox='0 0 16 16'
						>
							<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
						</svg>
					</div>
				)}
			</div>
			<div className='respuetasPregunta'>
				<div className='buttonsSeleccionRespuesta'>
					<div
						className='quitarSeleccion centrador'
						onClick={() => {
							if (NumeroPreguntas.length < numeroMaximoPuntuacion) {
								setNumeroPreguntas([
									...NumeroPreguntas,
									NumeroPreguntas.length + 1,
								]);
								modificarNumeroMaximo(NumeroPreguntas.length + 1, id);
							}
						}}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='24'
							height='24'
							fill='currentColor'
							className='bi bi-plus-circle'
							viewBox='0 0 16 16'
						>
							<path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
							<path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
						</svg>
					</div>
					<div
						className=' anadirSeleccion centrador '
						onClick={() => {
							if (NumeroPreguntas.length > 1) {
								setNumeroPreguntas(NumeroPreguntas.slice(0, -1));
								modificarNumeroMaximo(NumeroPreguntas.length - 1, id);
							}
						}}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='24'
							height='24'
							fill='currentColor'
							className='bi bi-dash-circle'
							viewBox='0 0 16 16'
						>
							<path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
							<path d='M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z' />
						</svg>
					</div>
				</div>
				<div className='opcionesSeleccionRespuesta'>
					{NumeroPreguntas.map((numero) => (
						<div className='valorSeleccion'>{numero}</div>
					))}
				</div>
			</div>
			<div className='opcionesRespuesta'>
				<div
					className='opcionRespuesta respuestaObligatoria'
					onClick={() => preguntaObligatoria(id)}
				>
					<div className='centrador'>
						{pregunta.obligatoria ? (
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='24'
								height='24'
								fill='currentColor'
								className='bi bi-toggle-on'
								viewBox='0 0 16 16'
							>
								<path d='M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z' />
							</svg>
						) : (
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='24'
								height='24'
								fill='currentColor'
								className='bi bi-toggle-off'
								viewBox='0 0 16 16'
							>
								<path d='M11 4a4 4 0 0 1 0 8H8a4.992 4.992 0 0 0 2-4 4.992 4.992 0 0 0-2-4h3zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM0 8a5 5 0 0 0 5 5h6a5 5 0 0 0 0-10H5a5 5 0 0 0-5 5z' />
							</svg>
						)}
					</div>
					<div>Requerida</div>
				</div>
				<div
					className='opcionRespuesta eliminarRespuesta'
					onClick={() => eliminarPregunnta(id)}
				>
					<div className='centrador'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='24'
							height='24'
							fill='currentColor'
							className='bi bi-trash'
							viewBox='0 0 16 16'
						>
							<path d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z' />
							<path
								fillRule='evenodd'
								d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'
							/>
						</svg>
					</div>
					<div>Eliminar</div>
				</div>
				{/*
                <div className='opcionRespuesta duplicarRespuesta'
                onClick={() => duplicarRespuesta(id)}>
                    <div className='centrador'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 22h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2zm2-9h3v-3h2v3h3v2h-3v3H9v-3H6v-2z"></path><path d="M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"></path></svg>
                    </div>
                    <div>Duplicar</div>
                </div>
                 */}
			</div>
		</div>
	);
};
